<template>
  <main v-loading="loading" class="mb-[20px]">
    <StatisticBlock :data="displayData" />
  </main>
</template>

<script setup>
import StatisticBlock from '@/components/Report/StatisticBlock.vue'
import { FindMemberRebateWalletYearExpirations } from '@/api/rebate'
import store from '@/store'
import { computed, onMounted, ref, watch } from 'vue'
import { map } from 'lodash'
import { formatDate } from '@/utils/date'
import { t } from '@/plugins/i18n/i18n'

const props = defineProps({
  memberId: {
    type: String,
  },
  loading: {
    type: Boolean,
  },
  rebateWalletBalance: {
    type: Number,
    default: 0,
  },
})

watch(props, async () => {
  if (props.loading) await findMemberRebateWalletYearExpirations()
})

const shopId = computed(() => store.getters.shop)
const data = ref([])
const displayData = computed(() => {
  const res = map(data.value, i => {
    return {
      label: `${formatDate(i.expirationDate, 'YYYY/MM/DD')} ${t('member.tab.rebate.walletStatistic.expiresOn')}`,
      value: i.balance,
    }
  })
  res.unshift({
    label: t('member.tab.rebate.walletStatistic.totalRebate'),
    value: props.rebateWalletBalance,
    showNegativeSign: true,
  })
  return res
})

const findMemberRebateWalletYearExpirations = async () => {
  const [res, err] = await FindMemberRebateWalletYearExpirations({
    shopId: shopId.value,
    memberId: props.memberId,
  })
  if (err) {
    window.$message.error(err)
    return
  }
  data.value = res
}

onMounted(async () => {
  await findMemberRebateWalletYearExpirations()
})
</script>

<style scoped lang="postcss">

</style>
